import { AddButton } from "../../components/AddButton";
import {
	ChipField,
	Datagrid,
	ReferenceArrayField,
	ReferenceField,
	SingleFieldList,
	TextField,
	useGetManyReference,
	useRecordContext,
	useRefresh,
} from "react-admin";
import { OrganEventRecord } from "../organ_events/types";
import { OrganRecord } from "./types";
import { RemoveWithConfirmButton } from "../../components/RemoveWithConfirmButton";
import { topologicalSort } from "../missions/dashboard/ordering";
import { useOrganPermission } from "../../permissions";
import { useScreenWidth } from "../../media";

const RemoveEventFromOrganButton = () => {
	const event = useRecordContext<OrganEventRecord>();
	const refresh = useRefresh();
	const { hasPermissionInOrgan } = useOrganPermission("organ-events.delete");

	return hasPermissionInOrgan(event.organ_id) ? (
		<RemoveWithConfirmButton
			confirmContent="Are you sure you want to remove the event?"
			notifyMessage="Event removed"
			resource="organ-events" // React Admin does not populate resource name from the context so I had to pass it
			onDelete={refresh}
		/>
	) : null;
};

const sort = { field: "id", order: "ASC" };

const AddEventButton = () => {
	const organ = useRecordContext<OrganRecord>();
	const { hasPermissionInOrgan } = useOrganPermission("organ-events.create");

	return hasPermissionInOrgan(organ.id) ? (
		<AddButton
			resource="organ-events"
			foreignKey="organ_id"
			label="Add new event"
		/>
	) : null;
};

export const OrganEvents = () => {
	const organ = useRecordContext<OrganRecord>();
	const mediumScreen = useScreenWidth("sm");

	const { data, total, isLoading } = useGetManyReference<OrganEventRecord>(
		"organ-events",
		{
			target: "organ_id",
			id: organ.id,
			pagination: {
				page: 1,
				perPage: 1000, // load all events to sort them - assuming an organ will not have more that 1k events
			},
			sort: sort,
		}
	);

	if (!data) return null;

	const { immediate, remaining } = topologicalSort(data);
	const organEvents = [...immediate, ...remaining];

	return (
		<>
			<Datagrid
				data={organEvents}
				total={total}
				isLoading={isLoading}
				sort={sort}
				bulkActionButtons={false}
				rowClick="edit"
				resource="organ-events"
			>
				<TextField label="Event" source="name" />
				{mediumScreen && (
					<ReferenceField
						source="depends_on"
						reference="organ-events"
						link={false}
					>
						<TextField source="name" />
					</ReferenceField>
				)}
				<ReferenceArrayField
					label="Notification channels"
					source="channel_ids"
					reference="channels"
				>
					<SingleFieldList>
						<ChipField source="name" />
					</SingleFieldList>
				</ReferenceArrayField>
				<RemoveEventFromOrganButton />
			</Datagrid>
			<AddEventButton />
		</>
	);
};
